export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.293 6.293a1 1 0 000 1.414l6 6 1.414-1.414L2.414 7l5.293-5.293L6.293.293l-6 6z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "8",
    "height": "14",
    "viewBox": "0 0 8 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};